<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Customer Sub Account Checkers Queue</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CustomerSubAccountCheckersQueueTable></CustomerSubAccountCheckersQueueTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Create Customer Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Customer Checkers Queue",
    meta: [{ name: "Customer Checkers Queue", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Checkers Queue",

      items: [
        {
          text: "Customers",
          href: "/"
        },
        {
          text: "Customers",
          active: true
        }
      ],
    };
  },
  methods: {}
}
</script>
